module.exports = __webpack_public_path__ + "static/media/fx.e737497a.svg";